import { Modal } from "antd"
import { useProcessRefundRequest } from "@mimber/client/mimber-organization"
import { message } from "@mimber/ui-web"
import type { EventRefundRequestWithMemberDto } from "@mimber/schema"

export const useProcessRefundModal = (
  eventUuid: string,
  onSuccess?: () => void
) => {
  const [modal, contextHolder] = Modal.useModal()
  const mutation = useProcessRefundRequest(eventUuid)

  const showProcessRefundModal = (
    refund: EventRefundRequestWithMemberDto
  ): void => {
    modal.confirm({
      title: "Process Refund",
      content:
        "This will process the Stripe refund. This action cannot be undone.",
      okText: "Process Refund",
      okType: "danger",
      cancelText: "Cancel",
      onOk: () =>
        new Promise<void>((resolve, reject) => {
          mutation.mutate(refund.uuid, {
            onSuccess: () => {
              message.success("Refund processed")
              onSuccess?.()
              resolve()
            },
            onError: (error) => {
              message.error(`Failed to process refund: ${error.message}`)
              reject()
            },
          })
        }),
    })
  }

  return {
    contextHolder,
    showProcessRefundModal,
  }
}
